import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class Sector extends ApplicationRecord {
  static jsonapiType = "sub_sectors";

  @Attr() name: string;
}

export default Sector;
